import { defineStore } from "pinia";
import SystemService from "@/services/SystemService";
import capabilityUtils from "@/utils/capabilityUtils.cjs";

const {
  normalizeCapabilities,
  hasModule,
  hasAllModules,
  hasAnyModules,
  isOffline,
  isDenied,
} = capabilityUtils;

export const useEntitlementStore = defineStore("entitlements", {
  state: () => ({
    snapshot: null,
    isLoading: false,
    loadFailed: false,
  }),
  getters: {
    isLoaded: (state) => state.snapshot !== null,
    hasModule: (state) => (moduleId) => hasModule(state.snapshot, moduleId),
    hasAllModules: (state) => (moduleIds) => hasAllModules(state.snapshot, moduleIds),
    hasAnyModules: (state) => (moduleIds) => hasAnyModules(state.snapshot, moduleIds),
    isOffline: (state) => isOffline(state.snapshot),
    isDenied: (state) => isDenied(state.snapshot),
  },
  actions: {
    setCapabilities(payload) {
      const normalized = normalizeCapabilities(payload);
      if (!normalized) {
        this.snapshot = null;
        this.loadFailed = true;
        throw new Error("The server returned an invalid module capability response.");
      }

      this.snapshot = normalized;
      this.loadFailed = false;
      return normalized;
    },

    async loadCapabilities() {
      this.isLoading = true;
      try {
        const response = await SystemService.getCapabilities();
        return this.setCapabilities(response?.data);
      } catch (error) {
        this.snapshot = null;
        this.loadFailed = true;
        throw error;
      } finally {
        this.isLoading = false;
      }
    },
  },
});
